module.exports = __webpack_public_path__ + "assets/img/vodacom.jpg?e11b9301fb83d2b2a311fd5aed411288";